import React from 'react';
import PageHeader from 'components/common/PageHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OrderInfo from './OrderInfo';
import OrderedProducts from './OrderedProducts';
import SoftBadge from 'components/common/SoftBadge';
import { useParams } from 'react-router-dom';
import { orders } from '../allorders/DataOrders';

const OrderDetails = () => {
 const { id } = useParams();
 const order = orders.find(order => order.id === parseInt(id));

 if (!order) {
  return <p>No se puede encontrar la orden</p>;
 }

 const status = ['warning', 'stream'];
 switch (order.status) {
  case 'Completed':
   status[0] = 'success';
   status[1] = 'check';
   break;
  case 'In Progress':
   status[0] = 'primary';
   status[1] = 'redo';
   break;
  case 'Pending':
   status[0] = 'warning';
   status[1] = 'stream';
   break;
  case 'On Hold':
   status[0] = 'secondary';
   status[1] = 'ban';
   break;
  default:
   status[0] = 'warning';
   status[1] = 'stream';
 }

 return (
  <>
   <PageHeader title={`Order Details: #${order.id}`} titleTag="h5" className="mb-3">
    <p className="fs--1 mt-1">{order.createAt}</p>
    <div>
     <strong className="me-2">Status: </strong>
     <SoftBadge pill bg={status[0]} className="fs--2">
      {order.status}
      <FontAwesomeIcon icon={status[1]} className="ms-1" transform="shrink-2" />
     </SoftBadge>
    </div>
   </PageHeader>
   <OrderInfo order={order} />
   <OrderedProducts />
  </>
 );
};

export default OrderDetails;
